<template>
    <div style="background-color: #2d3640; width: 100%; height: 100vh; ">
      <loader v-if="!loadedPage"></loader>
      <div v-else>
        <div style="border-bottom: 1px solid #5e6b79; height: 60px; position: fixed; width: 100%; z-index: 9999999; background-color: #2d3640; ">
          <div style=" float: right; padding-top: 15px; margin-right: 25px;">
            <div @click="routeBackOnShowCase()">
              <img style="height: 28px; opacity: 0.7; cursor: pointer;" src="https://gcdn.bionluk.com/site/icon/ic_close_white.svg"/>
            </div>
          </div>
          <div style="padding: 8px 30px;">
            <p style="color: #dde3eb; font-size: 22px;">{{ foundCategory.name }}</p>
            <p style="color: #8b95a1; font-size: 14px;"><span style="color: #5e6b79">by </span>
              <router-link :to="`/${portfolio.user.username}`">{{portfolio.user.username}}</router-link>
            </p>
          </div>
        </div>
        <div style="text-align: center; margin: 60px auto 0;">

          <div @click="activateIframe(portfolio)" v-if="!showIframe && portfolio.video_url && (portfolio.file_type === 'audio' || portfolio.file_type === 'video')" class="playIcon" style="text-align: center; width: 100%; margin: 0 auto; ">
            <span style=" cursor:pointer;position: absolute; margin-top: 280px; margin-left: -50px; display: inline-block;height: 100px; width: 100px; border: 2px solid white; background-color: white; border-radius: 50%; ">
              <img style=" flex:1;height: 100px; width: 100px; " :src="$root.CDN_SITE + 'icon/ic_play_circle_fill.svg'">
            </span>
          </div>

          <div v-if="videoLoader && portfolio.video_url && (portfolio.file_type === 'audio' || portfolio.file_type === 'video')" style="position: relative;width: 100%;height: 100%;">
            <img :style="'width:1170px;object-fit:cover'" :src="portfolio.image_url_original">
            <div style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);">
              <loader style="height: 30px;width: 30px;"/>
            </div>
          </div>

          <div class="mediaArea">
            <div v-if="showIframe">
              <iframe @load="deactivateIframeLoader()" v-show="!videoLoader" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" width="1170" height="659" frameborder="0" scrolling="no" :src="'https://api.bionluk.com/general/video/' + portfolio.uuid+'/portfolio_attachment'"></iframe>
            </div>
            <div @click="activateIframe(portfolio)" v-if="!showIframe && (portfolio.file_type === 'audio' || portfolio.file_type === 'video') ">
              <img class="poster" style="width: 1170px; " :src="portfolio.image_url_original"/>
            </div>
          </div>

          <div v-for="item in portfolio.items" v-if="(portfolio.file_type !== 'audio' && portfolio.file_type !== 'video') " style="text-align: center">
            <img style="background-color: white; margin-top: 20px;  max-width: 1170px; box-shadow: 0 0 20px rgba(0,0,0,0.8);" :src="item.image_url_original"/>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

	export default {
	  name: "src-pages-body-showCase-attachment-v1",
    data() {
			return {

        loadedPage: false,
        portfolio: null,
        foundCategory: null,
        showIframe: null,
        videoLoader: false
      }
		},

    methods:{
      deactivateIframeLoader() {
        this.videoLoader = false;
      },
      routeBackOnShowCase() {
    		if (this.$store.state.showCase.byModal) {
          this.$router.push({path: this.$store.state.showCase.from, query: this.$store.state.showCase.query});
        } else {
    			if (this.$store.state.showCase.data) {
            this.$router.push(this.$store.state.route.from.fullPath);
          } else {
    				this.$router.push(`/freelancer-vitrin/${this.portfolio.uuid}`)
          }
        }
      },

      activateIframe(portfolio) {
        this.videoLoader = true;
      	if(portfolio.video_url && (portfolio.file_type === 'audio' || portfolio.file_type === 'video')) {
          this.showIframe = true;
        }
      }
    },

    created() {
      this.api.seller.getPortfolio(this.$store.state.routerParams[0], "attachment", this.$Progress)
      .then(async ({data}) => {
        let result = data;
        if (result.success) {
        	this.loadedPage = true;
        	this.portfolio = result.data.portfolio;
        	this.foundCategory = await this.findCategoryByID(this.portfolio.category_id);
          this.$store.state.indexHTMLTitle = result.data.meta.title;
          this.$store.state.indexHTMLMetaDescription = result.data.meta.description;


          this.Helper.trackEvents.pageView(this.Helper.projectShowcaseAttachmentPageProps(result.data.portfolio));
        } else {
          this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
        }
      })
      .catch(err => {
        this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
      })
    }
	}

</script>

<style scoped>

</style>
